import { render, staticRenderFns } from "./Joke.vue?vue&type=template&id=4046b628&scoped=true&lang=pug&"
import script from "./Joke.vue?vue&type=script&lang=js&"
export * from "./Joke.vue?vue&type=script&lang=js&"
import style0 from "./Joke.vue?vue&type=style&index=0&id=4046b628&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046b628",
  null
  
)

export default component.exports